import { html, LitElement, property } from '../../_snowpack/pkg/lit-element.js';
import { signInUsers, registerEmailandPassword, updateDetailsafterSignup, fireAuthState } from '../server/firebase.config.js';
import { take } from '../../_snowpack/pkg/rxjs/operators.js';
import { routerHistory, outlet } from '../../_snowpack/pkg/eagrouter.js';

class home extends LitElement {
  createRenderRoot() {
    return this;
  }

  async signup(event) {
    event.preventDefault();
    const values = Array.from(event.target.elements).map(item => ({
      name: item.name,
      value: item.value
    }));
    values.pop();
    values.pop();
    const valueFields = {};

    for (const items in values) {
      const {
        name,
        value
      } = values[items];
      valueFields[name] = value;
    } // console.log(valueFields)
    // return


    try {
      const user = await registerEmailandPassword(valueFields.email, valueFields.password);
      await user.user.sendEmailVerification();
      await user.user.updateProfile({
        displayName: `${valueFields.cname} ${valueFields.cnip}`
      });
      await updateDetailsafterSignup(user.user.uid, valueFields.cname, valueFields.cnip, valueFields.phone);
      outlet('home');
    } catch (error) {
      console.error(error);
    }
  }

  async login(event) {
    event.preventDefault();
    const values = Array.from(event.target.elements).map(item => ({
      name: item.name,
      value: item.value
    }));
    values.pop();
    const valueFields = {};

    for (const items in values) {
      const {
        name,
        value
      } = values[items];
      valueFields[name] = value;
    } // console.log(valueFields)
    // return


    try {
      const user = await signInUsers(valueFields.email, valueFields.password);

      if (user) {
        outlet('home');
      }
    } catch (error) {
      console.error(error);

      if (error.code === 'auth/wrong-email') {
        alert('Invalid Email');
      }

      if (error.code === 'auth/wrong-password') {
        alert('Invalid Password');
      }

      if (error.code === 'auth/user-not-found') {
        alert('User Not found');
      }
    }
  }

  blurEvent(event, amount, textContent) {
    // alert('i bluredd')
    const formParent = event.target.parentNode;
    const errorSpan = formParent.querySelector('.error'); // console.log(event.target.value)

    if (event.target.value.length < amount) {
      errorSpan.textContent = textContent;
      errorSpan.style = "display: block";
      formParent.classList.add('hasError');
    } else {
      errorSpan.textContent = '';
      errorSpan.style = "display: none";
      formParent.classList.remove('hasError');
    }

    const label = formParent.querySelector('label');
    label.classList.remove('active');
  }

  focusEvent(event) {
    const formParent = event.target.parentNode;
    const label = formParent.querySelector('label');
    label.classList.add('active');
  }

  firstUpdated() {
    // form switch
    $('a.switch').click(function (e) {
      $(this).toggleClass('active');
      e.preventDefault();

      if ($('a.switch').hasClass('active')) {
        $(this).parents('.form-peice').addClass('switched').siblings('.form-peice').removeClass('switched');
      } else {
        $(this).parents('.form-peice').removeClass('switched').siblings('.form-peice').addClass('switched');
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();
    fireAuthState.subscribe(user => console.log(user));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  render() {
    return html` 
        	
            
<div class="container">
   <section id="formHolder">

      <div class="row">

         <!-- Brand Box -->
         <div class="col-sm-6 brand">
            <!-- <a href="#" class="logo">MR <span>.</span></a> -->

            <div class="heading">
            <img src="images/xdisc.png" width="" height=""/>
            </div>

            <div class="success-msg">
               <p>Great! You are one of our members now</p>
               <a href="#" class="profile">Your Profile</a>
            </div>
         </div>


         <!-- Form Box -->
         <div class="col-sm-6 form">

            <!-- Login Form -->
            <div class="login form-peice switched">
               <form class="login-form" @submit=${this.login}>
                  <div class="form-group">
                     <label for="loginemail">Email</label>
                     <input type="email" name="email" id="loginemail" class="email" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your email address');
    }} >
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="loginpassword">Password</label>
                     <input type="password" name="password" id="loginpassword" class="pass" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your password');
    }} >
                     <span class="error"></span>
                  </div>

                  <div class="CTA">
                     <input type="submit" value="Login">
                     <a href="#" class="switch">I'm New</a>
                  </div>
               </form>
            </div><!-- End Login Form -->


            <!-- Signup Form -->
            <div class="signup form-peice" >
               <form class="signup-form main-form" @submit=${this.signup}>

                  <div class="form-group">
                     <label for="email">Email Adderss</label>
                     <input type="email" name="email" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your email address');
    }} id="email" class="email">
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="phone">Phone Number </label>
                     <input type="text" name="phone" @focus=${this.focusEvent}  @blur=${event => {
      this.blurEvent(event, 6, 'Please type your phone number');
    }} class="phone" id="phone">
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="cname">Company Name</label>
                     <input type="text" name="cname" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your Company Name');
    }} id="name" class="cname">
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="cnip">Company Nip</label>
                     <input type="text" name="cnip" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your Company Nip');
    }} id="cnip" class="cnip">
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="password">Password</label>
                     <input type="password" name="password" @focus=${this.focusEvent} @blur=${event => {
      this.blurEvent(event, 6, 'Please type your password');
    }} id="password" class="pass">
                     <span class="error"></span>
                  </div>

                  <div class="form-group">
                     <label for="passwordCon">Confirm Password</label>
                     <input type="password" name="passwordCon" id="passwordCon" class="passConfirm">
                     <!-- <span class="error"></span> -->
                  </div>

                  <div class="CTA">
                     <input type="submit" value="Signup Now" id="submit">
                     <a href="#" class="switch">I have an account</a>
                  </div>
               </form>
              
            </div><!-- End Signup Form -->
         </div>
      </div>

   </section>


   <footer>
      <p>
         &copy; all right reserved Xdisc s.a 2021
      </p>
   </footer>

</div>

<style>
    body {
  font-family: "Montserrat", sans-serif;
  background: #f7edd5;
}

.container {
  max-width: 900px;
}

a {
  display: inline-block;
  text-decoration: none;
}

input {
  outline: none !important;
}

input:focus {
  top: 100px;
  left: 100px;
  transform: translate(0);
}

h1 {
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 40px;
  font-weight: 700;
}

section#formHolder {
  padding: 50px 0;
}

.brand {
  padding: 20px;
  background: url(https://goo.gl/A0ynht);
  background-size: cover;
  background-position: center center;
  color: #fff;
  min-height: 540px;
  position: relative;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.3);
  transition: all 0.6s cubic-bezier(1, -0.375, 0.285, 0.995);
  z-index: 9999;
}
.brand.active {
  width: 100%;
}
.brand::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: -1;
}
.brand a.logo {
  color: #f95959;
  font-size: 20px;
  font-weight: 700;
  text-decoration: none;
  line-height: 1em;
}
.brand a.logo span {
  font-size: 30px;
  color: #fff;
  transform: translateX(-5px);
  display: inline-block;
}
.brand .heading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  transition: all 0.6s;
}
.brand .heading.active {
  top: 100px;
  left: 100px;
  transform: translate(0);
}
.brand .heading h2 {
  font-size: 70px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 0;
}
.brand .heading p {
  font-size: 15px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 2px;
  white-space: 4px;
  font-family: "Raleway", sans-serif;
}
.brand .success-msg {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 60px;
}
.brand .success-msg p {
  font-size: 25px;
  font-weight: 400;
  font-family: "Raleway", sans-serif;
}
.brand .success-msg a {
  font-size: 12px;
  text-transform: uppercase;
  padding: 8px 30px;
  background: #f95959;
  text-decoration: none;
  color: #fff;
  border-radius: 30px;
}
.brand .success-msg p, .brand .success-msg a {
  transition: all 0.9s;
  transform: translateY(20px);
  opacity: 0;
}
.brand .success-msg p.active, .brand .success-msg a.active {
  transform: translateY(0);
  opacity: 1;
}

.form {
  position: relative;
  
}
.form .form-peice {
  background: #fff;
  min-height: 480px;
  margin-top: 30px;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
  color: #bbbbbb;
  padding: 30px 0 60px;
  transition: all 0.9s cubic-bezier(1, -0.375, 0.285, 0.995);
  position: absolute;
  top: 0;
  left: -30%;
  width: 130%;
  overflow: hidden;
}
.form .form-peice.switched {
  transform: translateX(-100%);
  width: 100%;
  left: 0;
}
.form form {
  padding: 0 40px;
  margin: 0;
  width: 70%;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
}
.form form .form-group {
  margin-bottom: 5px;
  position: relative;
}
.form form .form-group.hasError input {
  border-color: #f95959 !important;
}
.form form .form-group.hasError label {
  color: #f95959 !important;
}
.form form label {
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  font-family: "Montserrat", sans-serif;
  transform: translateY(40px);
  transition: all 0.4s;
  cursor: text;
  z-index: -1;
}
.form form label.active {
  transform: translateY(10px);
  font-size: 10px;
}
.form form label.fontSwitch {
  font-family: "Raleway", sans-serif !important;
  font-weight: 600;
}
.form form input:not([type=submit]) {
  background: none;
  outline: none;
  border: none;
  display: block;
  padding: 10px 0;
  width: 100%;
  border-bottom: 1px solid #eee;
  color: #444;
  font-size: 15px;
  font-family: "Montserrat", sans-serif;
  z-index: 1;
}
.form form input:not([type=submit]).hasError {
  border-color: #f95959;
}
.form form span.error {
  color: #f95959;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  position: absolute;
  bottom: -20px;
  right: 0;
  display: none;
}
.form form input[type=password] {
  color: #f95959;
}
.form form .CTA {
  margin-top: 30px;
}
.form form .CTA input {
  font-size: 12px;
  text-transform: uppercase;
  padding: 5px 30px;
  background: #f95959;
  color: #fff;
  border-radius: 30px;
  margin-right: 20px;
  border: none;
  font-family: "Montserrat", sans-serif;
}
.form form .CTA a.switch {
  font-size: 13px;
  font-weight: 400;
  font-family: "Montserrat", sans-serif;
  color: #bbbbbb;
  text-decoration: underline;
  transition: all 0.3s;
}
.form form .CTA a.switch:hover {
  color: #f95959;
}

footer {
  text-align: center;
}
footer p {
  color: #777;
}
footer p a, footer p a:focus {
  color: #b8b09f;
  transition: all 0.3s;
  text-decoration: none !important;
}
footer p a:hover, footer p a:focus:hover {
  color: #f95959;
}

@media (max-width: 768px) {
  .container {
    overflow: hidden;
  }

  section#formHolder {
    padding: 0;
  }
  section#formHolder div.brand {
    min-height: 200px !important;
  }
  section#formHolder div.brand.active {
    min-height: 100vh !important;
  }
  section#formHolder div.brand .heading.active {
    top: 200px;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  section#formHolder div.brand .success-msg p {
    font-size: 16px;
  }
  section#formHolder div.brand .success-msg a {
    padding: 5px 30px;
    font-size: 10px;
  }
  section#formHolder .form {
    width: 80vw;
    min-height: 500px;
    margin-left: 10vw;
  }
  section#formHolder .form .form-peice {
    margin: 0;
    top: 0;
    left: 0;
    width: 100% !important;
    transition: all 0.5s ease-in-out;
  }
  section#formHolder .form .form-peice.switched {
    transform: translateY(-100%);
    width: 100%;
    left: 0;
  }
  section#formHolder .form .form-peice > form {
    width: 100% !important;
    padding: 60px;
    left: 50%;
  }
 
}
@media (max-width: 480px) {
  section#formHolder .form {
    width: 100vw;
    margin-left: 0;
  }

 

  h2 {
    font-size: 50px !important;
  }
}
</style>

        `;
  }

}

customElements.define('login-page', home);